export const GET_ALL_FEATURES_START = 'GET_ALL_FEATURES_START';
export const GET_ALL_FEATURES_SUCCESS = 'GET_ALL_FEATURES_SUCCESS';
export const GET_ALL_FEATURES_ERROR = 'GET_ALL_FEATURES_ERROR';
